import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from 'react';
import HideAppBar from "../../widgets/header/HideAppBar";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {
	Card,
	CardContent,
	CardHeader,
	Container,
	DialogActions, FormControl, InputLabel, MenuItem, Select, Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import moment from "moment";
import {getAccountInfo} from "../../../utils/GenericUtils";
import {
	getAllQuaranteneByMonth,
	getQuaranteneByEndDay,
	resetQuaranteneDay
} from "../../../services/QuaranteneServices";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../reducers/QuaranteneReducer";
import SimpleDialog from "../../widgets/dialogs/SimpleDialog";
import Button from "@mui/material/Button";
import QuarantenaCard from "../quarantene/detail/QuarantenaCard";
import {onClickDetails} from "../../../services/AutomationServices";
import {AUTOMATION_INITIAL_STATE, AutomationReducer, initAutomationState} from "../../../reducers/AutomationReducer";
import {setOpenSnackbar} from "../../../services/AppServices";
import {AppContext} from "../../../App";
import {useHistory} from "react-router-dom";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import CalendarHeader from "./viste/mese/CalendarHeader";
import ScadenziarioCalendarDays from "./viste/mese/ScadenziarioCalendarDays";
import ScadenziarioCell from "./viste/mese/ScadenziarioCell";
import {useSessionStorage} from "../../../utils/hooks/SessionStorageHook";

const GestioneScadenziario = () => {
	const classes = BaseStyle();
	const [currentMonth, setCurrentMonth] = useState(new Date());
	const [selectedDate, setSelectedDate] = useState(new Date());
	const [state, dispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	const [automationState, automationDispatch] = useReducer(AutomationReducer, AUTOMATION_INITIAL_STATE, initAutomationState);
	const appContext = useContext(AppContext);
	let history = useHistory();
	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState("");
	const [pageNumber, setPageNumber] = useState(0);
	const observer = useRef();
	const [stato, setStato] = useSessionStorage("statoCal", "IN CORSO");
	const [giorno, setGiorno] = useSessionStorage("giornoCal", "dataFine");
	const [tipo, setTipo] = useSessionStorage("tipoCal", "Isolamento");
	
	const lastTicketElementRef = useCallback(node => {
		if (state.loadingGetQuaranteneByDay) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && state.quaranteneDayPayload.length > 0) {
				let day = selectedDate
				day.setHours(0);
				day.setMinutes(0);
				day.setSeconds(0);
				day.setMilliseconds(0);
				getQuaranteneByEndDay({
					[giorno]: day,
					tipo: tipo,
					stato: stato,
					active: null,
				}, dispatch, pageNumber + 1);
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [state.loadingGetQuaranteneByDay, state.quaranteneDayPayload, selectedDate, pageNumber, stato, giorno, tipo])
	
	const onDateClick = day => {
		setPageNumber(0);
		resetQuaranteneDay(dispatch);
		setOpen(true);
		let selectedDay = day
		selectedDay.setHours(0);
		selectedDay.setMinutes(0);
		selectedDay.setSeconds(0);
		selectedDay.setMilliseconds(0);
		setSelectedDate(selectedDay);
		getQuaranteneByEndDay({
			[giorno]: selectedDay,
			tipo: tipo,
			stato: stato,
			active: null,
		}, dispatch, pageNumber);
	};
	
	const onClickQuarantena = (quarantena) => {
		setSelected(quarantena);
		onClickDetails(quarantena.idFocolaio, "focolaio", "modify", automationDispatch);
	}
	
	useEffect(() => {
		if (!automationState.loadingOnClick && automationState.errorOnClick === "") {
			if (automationState.operatorOnClick.replace("ERR_", "").includes(getAccountInfo().alias)) {
				history.push("/gestione/focolai/" + selected.idFocolaio + "/soggetto/" + selected.soggetto.idSoggetto);
			} else {
				setOpenSnackbar("warning", ("La quarantena è al momento gestita da " + automationState.operatorOnClick?.replace("ERR_", "") + ". Ritenta e sari più fortunato :)"), appContext.dispatch)
			}
		}
	}, [automationState.loadingOnClick, automationState.errorOnClick, automationState.operatorOnClick, selected, history, appContext.dispatch])
	
	useEffect(() => {
		getAllQuaranteneByMonth(currentMonth, dispatch)
	}, [currentMonth, dispatch])
	
	useEffect(() => {
		setPageNumber(0);
	}, [selectedDate, tipo, giorno, stato])
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Calendario ordinanze"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent className={classes.calendar}>
									
									{
										state.loadingGetQuaranteneByMonth ?
											
											<React.Fragment>
												<CalendarHeader currentMonth={currentMonth} setCurrentMonth={setCurrentMonth}/>
												<ScadenziarioCalendarDays currentMonth={currentMonth}/>
												<ScadenziarioCell currentMonth={currentMonth} selectedDate={selectedDate}
												                  quarantenaState={state} isLoading={true}
												                  onDateClick={onDateClick}/>
											</React.Fragment> :
											state.errorGetQuaranteneByMonth !== "" ? <Alert severity="error" style={{borderRadius: 24}}>
													<AlertTitle>Errore</AlertTitle>
													Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta
													gli sviluppatori.
												</Alert> :
												<React.Fragment>
													<CalendarHeader currentMonth={currentMonth} setCurrentMonth={setCurrentMonth}/>
													<ScadenziarioCalendarDays currentMonth={currentMonth}/>
													<ScadenziarioCell currentMonth={currentMonth} selectedDate={selectedDate}
													                  quarantenaState={state}
													                  onDateClick={onDateClick}/>
												</React.Fragment>
									}
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</main>
            <SimpleDialog
				open={open}
				handleClose={() => setOpen(false)}
				title={moment(selectedDate).format("D MMMM YYYY")}
				maxWidth={"md"}
				content={
					<React.Fragment>
						<Grid container spacing={2} style={{marginBottom: 20}}>
							<Grid item xs={3}>
								<FormControl variant={"outlined"} fullWidth={true}>
									<InputLabel htmlFor="grouped-native-select">Stato</InputLabel>
									<Select
										label={"Stato"}
										labelId="stato-label"
										id="grouped-native-select"
										value={stato}
										onChange={(e) => {
											setStato(e.target.value);
											resetQuaranteneDay(dispatch);
										}}
									>
										<MenuItem value={"IN CORSO"}>IN CORSO</MenuItem>
										<MenuItem value={"NUOVA"}>NUOVA</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={3}>
								<FormControl variant={"outlined"} fullWidth={true}>
									<InputLabel htmlFor="grouped-native-select-1">Giorno</InputLabel>
									<Select
										label={"Giorno"}
										labelId="giorno-label"
										id="grouped-native-select-1"
										value={giorno}
										onChange={(e) => {
											setGiorno(e.target.value);
											resetQuaranteneDay(dispatch);
										}}
									>
										<MenuItem value={"dataFine"}>Data fine</MenuItem>
										<MenuItem value={"dataInizio"}>Data inizio</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={3}>
								<FormControl variant={"outlined"} fullWidth={true}>
									<InputLabel htmlFor="grouped-native-select-2">Tipo</InputLabel>
									<Select
										label={"Tipo"}
										labelId="tipo-label"
										id="grouped-native-select-2"
										value={tipo}
										onChange={(e) => {
											setTipo(e.target.value);
											resetQuaranteneDay(dispatch);
										}}
									>
										<MenuItem value={"Isolamento"}>Isolamento</MenuItem>
										<MenuItem value={"Quarantena"}>Autosorveglianza</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={3}>
								<Button variant={"outlined"} onClick={
									() => getQuaranteneByEndDay({
										[giorno]: selectedDate,
										tipo: tipo,
										stato: stato,
										active: null,
									}, dispatch, pageNumber)}
								        style={{
									        height: "100%",
									        width: "100%",
								        }}
								>
									<b>Cerca</b>
								</Button>
							</Grid>
						</Grid>
						
						
						{
							state.quaranteneDay.length === 0 && <Typography>
								Non ci sono isolamenti con stato <b>{stato}</b> al giorno selezionato
							</Typography>
						}
						{
							state.quaranteneDay.map((quarantena, index) => {
								if (state.quaranteneDay.length === index + 1) {
									return (
										<Card ref={lastTicketElementRef} key={quarantena.id}
										      className={clsx(classes.roundBorder, classes.mailCard)}>
											<QuarantenaCard quarantena={quarantena} onclickQuarantena={onClickQuarantena}/>
										</Card>
									)
								} else {
									return (
										<Card key={quarantena.id} className={clsx(classes.roundBorder, classes.mailCard)}>
											<QuarantenaCard quarantena={quarantena} onclickQuarantena={onClickQuarantena}/>
										</Card>
									)
								}
							})
						}
						{state.loadingGetQuaranteneByDay &&
							<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
								<CardHeader
									avatar={<Skeleton variant="circular" height={40} width={40}/>}
									title={<Skeleton width={180}/>}
									subheader={<Skeleton width={260}/>}
									action={<Skeleton variant="circular" height={20} width={20}/>}
									style={{paddingBottom: 2}}
								/>
								<CardContent style={{paddingTop: 0, marginTop: -35}}>
									<Skeleton height={200}/>
								</CardContent>
							</Card>}
					</React.Fragment>
				}
				actions={
					<DialogActions>
						<Button onClick={() => setOpen(false)} size={"small"} variant={"contained"}
						        className={classes.roundButton} style={{borderRadius: 24}} color={"primary"} disableElevation>
							<b>Chiudi</b>
						</Button>
					</DialogActions>
				}
			/>
        </React.Fragment>
    );
};

export default React.memo(GestioneScadenziario)
